export default {"src":"/_next/static/media/logo-blesk.8d1cdbf8.svg","height":164,"width":400,"blurWidth":0,"blurHeight":0};